import UserTotalPayments from './UserTotalPayments';

export default UserTotalPayments;
